export function setUsdExchange(state, value) {
  state.usdExchange = value
}

export function setData(state, value) {
  state.step = value.step;
  state.surplus = value.surplus;
  state.qualification = value.qualification;
  state.rgInterestSuggested = value.rg_interest_suggested;
}

export function setUdis(state, value) {
  state.udis = parseFloat(value).toFixed(7);
}

export function setFundTiie(state, value) {
  state.fundTiie = value;
}

export function setFundTiieState(state, value) {
  state.fundTiieState = value;
}

export function setRgInterestBase(state, value) {
  state.rgInterestBase = value;
}

export function setTiiePercentagePoints(state, value) {
  state.tiiePercentagePoints = value;
}

export function setTiieQueryDate(state, value) {
  state.tiieQueryDate = value;
}
